import api from './axios';

export const notificationsAPI = {
  /**
   * GET /api/admin/notifications
   * @param {Object} params - page, per_page
   */
  getList: (params = {}) => api.get('/admin/notifications', { params }),

  /**
   * POST /api/admin/notifications
   * @param {{ title: string, description: string }} payload
   */
  send: (payload) => api.post('/admin/notifications', payload),

  /**
   * DELETE /api/admin/notifications/{id}
   */
  remove: (id) => api.delete(`/admin/notifications/${id}`),
};
